import { useI18n } from "@/lib/i18n";

const PRESS = [
  {
    outlet: "Houston Chronicle",
    quote:
      "A genre-defying Montrose newcomer that treats Soul and Mediterranean as one shared dialect of butter, lemon and confidence.",
    author: "— Camila Reyes, Food Editor",
  },
  {
    outlet: "Eater Houston",
    quote:
      "The $29 slider deal is not a marketing trick — it's a love letter to the lunch break.",
    author: "— Ana Méndez",
  },
  {
    outlet: "Texas Monthly",
    quote:
      "Brunch the way Paris should have invented it. Save the corner banquette for next time.",
    author: "— Jordan Ellis",
  },
];

const ACCOLADES = [
  { year: "2026", title: "Best New Restaurant", source: "Houston Press" },
  { year: "2026", title: "Top 10 Brunch in Texas", source: "Texas Monthly" },
  { year: "2026", title: "Wine List of Note", source: "James Beard Foundation" },
  { year: "2026", title: "Hot 25 Openings", source: "Eater Houston" },
];

export default function Press() {
  const { t } = useI18n();
  return (
    <section
      id="press"
      data-testid="press-section"
      className="bg-[#FDFBF7] py-24 md:py-36 border-t border-[#E4DECD]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-16">
          <div className="col-span-12 md:col-span-5">
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              {t("press.kicker")}
            </p>
            <h2
              data-testid="press-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-[#1A1713]"
            >
              {t("press.heading")}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:pt-12">
            <div className="grid grid-cols-2 gap-x-8 gap-y-7">
              {ACCOLADES.map((a) => (
                <div
                  key={a.title}
                  data-testid="accolade-row"
                  className="border-l-2 border-[#C98A4B] pl-4"
                >
                  <p className="font-mono-accent text-[12px] text-[#7A2021]">
                    {a.year}
                  </p>
                  <p className="font-serif-display text-xl md:text-2xl text-[#1A1713] mt-1 leading-snug">
                    {a.title}
                  </p>
                  <p className="text-[#5C5449] text-sm mt-1">{a.source}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 border-t border-[#E4DECD] pt-14">
          {PRESS.map((p, i) => (
            <figure
              key={i}
              data-testid="press-quote"
              className="bg-[#F5F2EA] p-7 md:p-9 flex flex-col"
            >
              <p className="font-mono-accent text-[12px] text-[#7A2021] mb-4">
                {p.outlet}
              </p>
              <blockquote className="font-serif-display italic text-2xl md:text-3xl text-[#1A1713] leading-snug flex-1">
                "{p.quote}"
              </blockquote>
              <figcaption className="font-mono-accent text-[12px] text-[#5C5449] mt-6">
                {p.author}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
